import React, { MouseEventHandler } from 'react'

import { ArrowSvg, LoadingSvg } from '@components/adgroup-svg/react'

import { ApartmentRoute, HouseAndLandRoute } from '@adUtilities/types'

interface LayerProps {
  isValid?: boolean
  label: string
  onClick: MouseEventHandler
  route?: ApartmentRoute | HouseAndLandRoute
  as?: 'a' | 'button'
  isProcessing?: boolean
}

function Layer({
  isValid,
  label,
  onClick,
  route,
  isProcessing,
  as: Tag = 'a',
}: LayerProps) {
  const isButton = Tag === 'button'

  return (
    <div>
      {isValid && (route || isButton) ? (
        <Tag
          href={!isButton ? route : undefined}
          type={isButton ? 'button' : undefined}
          onClick={onClick}
        >
          <span className="border-b-2 border-black">{label}</span>
          <span
            className={`${isProcessing ? 'pl-2' : 'border-b-2 border-black'}`}
          >
            {isProcessing ? (
              <LoadingSvg className="inline-block h-5 w-5 fill-white" />
            ) : (
              <ArrowSvg
                size="m"
                className="-mr-1 inline-block h-5 w-5"
                styles={{ rotate: '135deg' }}
                strokeColor="#000000"
              />
            )}
          </span>
        </Tag>
      ) : (
        <span>{label}</span>
      )}
    </div>
  )
}

export default Layer
